<template>
  <v-card
    class="d-flex align-center py-1 px-3 mb-2 member-wrapper"
    :class="{ deactivated: account.isDeleted }"
    flat
    @click="goToProfile"
  >
    <UserAvatar size="32px" fontSize="10px" class="mr-2" :account="account" />

    <div>
      <p
        class="body-2 font-weight-regular text-truncate mb-0"
        style="max-width: 194px;"
        :title="account.fullName"
      >
        {{ account.fullName }}
      </p>
      <p v-if="account.isDeleted" class="caption blue-grey--text mb-0">
        {{ $t('people.status.deactivated') }}
      </p>
    </div>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import UserAvatar from '@/components/UserAvatar.vue'

import userMixin from '@/mixins/userMixin.vue'
import mixin from '@/mixins/mixin.vue'

export default {
  name: 'Member',

  mixins: [userMixin, mixin],

  components: {
    UserAvatar,
  },

  props: {
    account: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapGetters(['organizationId']),
  },

  methods: {
    goToProfile() {
      this.navigateTo({
        name: 'profile',
        params: {
          organizationId: this.organizationId,
          userId: this.account.id,
        },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.member-wrapper {
  border-radius: 4px;

  &:hover {
    background-color: $color-blue-grey-lighten3;
  }
}

.deactivated {
  opacity: 0.7;
}
</style>
